enum StatusVerpal {
  Open = 'Open',
  Approved = 'Approved'
}

export {
  StatusVerpal
}
